import { Theme, TypographyProps } from '@freighthub/silhouette-core'
import { CSSProperties, ReactNode } from 'react'

export const TEXT: TMessageSectionType = 'text'
export const DOWNLOAD: TMessageSectionType = 'download'
export const ICON: TMessageSectionType = 'icon'
export const UPDATE_TABLE: TMessageSectionType = 'update_table'
export const COLLAPSE_TABLE: TMessageSectionType = 'collapse_table'
export const LABELED: TMessageSectionType = 'labeled'

type TMessageSectionType = 'text' | 'download' | 'icon' | 'update_table' | 'collapse_table' | 'labeled'

export interface IActivityMessageSection {
  _id?: string
  content?: string
  contentNode?: ReactNode
  name?: string
  style?: CSSProperties
  getStyle?: (theme: Theme) => CSSProperties
  type: TMessageSectionType
  tableContent?: string[][]
  lastChangedRows?: number[]
  translate?: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
  translationParams?: { [key: string]: any }
  label?: string
  url?: string
  linkText?: string
  hide?: boolean
  variant?: TypographyProps['variant']
}

export interface IActivityTitle {
  text: string
  translate?: boolean
}
